import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Addressify from '../elements/Addressify'
import Button from '../elements/Button'
import FormHOC from './FormHOC'
import InputRow from '../elements/InputRow'
import FancySelect from '../elements/FancySelect/FancySelect'
import { idStates } from '../constants'

const options = {
    postUrl: '/api/postVerifyAddress',
    success: 'Success! Your address is being verified and will be completed automatically within the next 48 hours.'
}
const state = {
    serviceAddress: '',
    unitType: '',
    unitNumber: '',
    streetNumber: '',
    streetName: '',
    streetType: '',
    suburb: '',
    state: '',
    postcode: ''
}

const VerifyAddressForm = (props) => {
    const [addressSelected, setAddressSelected] = useState(false)

    useEffect(() => {
        props.setDynamicValues({
            serviceId: props.serviceId
        })
    }, [props.serviceId])

    const handleExpandForm = event => {
        event.preventDefault()
        props.setExpandForm(true)
        setAddressSelected(true)
    }

    const handleAddressSelected = () => {
        setAddressSelected(true)
    }

    const handleSubmit = event => {
        event.preventDefault()
        if (props.expandForm || props.values.serviceAddress) {
            props.handleSubmit()
        }
    }

    return (
        <form onSubmit={handleSubmit} onKeyDown={props.handleKeyDown} className='verify-address-form'>
            {!props.expandForm
                ? <div className='d-flex flex-wrap flex-lg-nowrap'>
                    <div className='mr-2 flex-basis-100'>
                        <Addressify
                            label='Search address'
                            name='serviceAddress'
                            value={props.values.serviceAddress}
                            errors={props.errors}
                            handleSetAddress={props.setDynamicValues}
                            handleAddressSelected={handleAddressSelected}
                            placeholder='Start typing your physical address'
                        />
                        <div className='cant-find'>
                            <small>Cant find your address? <a href='#' onClick={handleExpandForm}>Enter it manually</a>.</small>
                        </div>
                    </div>
                    <div className='smaller-btn'>
                        <Button title='Verify' action={handleSubmit} />
                    </div>
                  </div>
                : ''}

            {props.expandForm
                ? <div className='row manual-form mt-4'>
                    <div className='col-12 d-flex flex-wrap'>
                        <div className='mr-4'>
                            <p className='font-small sub-bold m-0 mb-1'>Apt/Unit type</p>
                            <InputRow
                                name='unitType'
                                value={props.values.unitType}
                                placeholder='ie. Suite'
                                errors={props.errors}
                                handleChange={props.handleInputChange}
                                hideLabel
                                className='width-150'
                            />
                        </div>
                        <div className='mr-4'>
                            <p className='font-small sub-bold m-0 mb-1'>Apt/Unit number</p>
                            <InputRow
                                name='unitNumber'
                                value={props.values.unitNumber}
                                placeholder='ie. 12'
                                errors={props.errors}
                                handleChange={props.handleInputChange}
                                hideLabel
                                className='width-150'
                            />
                        </div>
                        <div className='mr-4'>
                            <p className='font-small sub-bold m-0 mb-1'>Street number</p>
                            <InputRow
                                name='streetNumber'
                                value={props.values.streetNumber}
                                placeholder='ie. 312'
                                errors={props.errors}
                                handleChange={props.handleInputChange}
                                hideLabel
                                className='width-150'
                            />
                        </div>
                        <div className='d-none d-lg-block w-100' />
                        <div className='mr-4'>
                            <p className='font-small sub-bold m-0 mb-1'>Street name</p>
                            <InputRow
                                name='streetName'
                                value={props.values.streetName}
                                placeholder=''
                                errors={props.errors}
                                handleChange={props.handleInputChange}
                                hideLabel
                                className='width-300'
                            />
                        </div>
                        <div className='mr-4'>
                            <p className='font-small sub-bold m-0 mb-1'>Street type</p>
                            <InputRow
                                name='streetType'
                                value={props.values.streetType}
                                placeholder='ie. Street'
                                errors={props.errors}
                                handleChange={props.handleInputChange}
                                hideLabel
                                className='width-300'
                            />
                        </div>
                        <div className='mr-4'>
                            <p className='font-small sub-bold m-0 mb-1'>Suburb</p>
                            <InputRow
                                name='suburb'
                                value={props.values.suburb}
                                placeholder=''
                                errors={props.errors}
                                handleChange={props.handleInputChange}
                                hideLabel
                                className='width-150'
                            />
                        </div>
                        <div className='d-none d-lg-block w-100' />
                        <div className='mr-4'>
                            <p className='font-small sub-bold m-0 mb-1'>State</p>
                            <FancySelect
                                list={idStates}
                                setValue={value => props.setDynamicValues({ state: value })}
                                label='State'
                                value={props.values.state}
                                className={props.errors && props.errors.state ? 'error' : ''}
                            />
                        </div>
                        <div>
                            <p className='font-small sub-bold m-0 mb-1'>Postcode</p>
                            <InputRow
                                name='postcode'
                                value={props.values.postcode}
                                placeholder=''
                                errors={props.errors}
                                handleChange={props.handleInputChange}
                                hideLabel
                                className='width-150'
                            />
                        </div>
                    </div>
                  </div>
                : ''}

            {props.children}

            {addressSelected || props.expandForm
                ? <div className='w-100 text-center text-md-left'>
                    {!props.expandForm ? <p className='bold'>{props.values.serviceAddress}</p> : ''}
                    <Button title='Verify address' action={handleSubmit} />
                  </div>
                : ''}
        </form>
    )
}

VerifyAddressForm.propTypes = {
    serviceId: PropTypes.number.isRequired,
    expandForm: PropTypes.bool.isRequired,
    setExpandForm: PropTypes.func.isRequired
}

export default FormHOC(VerifyAddressForm, state, options)



// WEBPACK FOOTER //
// ./resources/js/forms/VerifyAddressForm.js